import {
  Anchor,
  Flex,
  Space,
  Stack,
  Text,
  Title,
  useComputedColorScheme,
} from "@mantine/core";
import { SvgLogoBlack, SvgLogoWhite } from "./SvgLogo";

export const Header = () => {
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });
  return (
    <Flex direction="column" align="center" justify="center">
      <Title order={1} fw={600}>
        OCPI Schema Validator
      </Title>
      <Space h="xl" />
      <Text fw={700} size="xs">
        powered by
      </Text>
      <Space h="xs" />
      {computedColorScheme === "dark" ? (
        <Anchor href="https://solidstudio.io/" target="_blank">
          <SvgLogoWhite width={150} />
        </Anchor>
      ) : (
        <Anchor href="https://solidstudio.io/" target="_blank">
          <SvgLogoBlack width={150} />
        </Anchor>
      )}
    </Flex>
  );
};
